import { CoreDomainSearchStore } from '@wix/domains-search-suite';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { useCallback } from 'react';
import { TLD_PREFILL_QUERY_PARAM } from '../constants';
import { DomainSearchGateModule } from '../module/domainSearchGate.module';
import { buildDomainFromSiteName, isDefaultSiteName } from '../utils/siteName';
import { tldClickSearchService } from './tldClickSearchService';
import { useViewTransition } from './useViewTransition';
export const useOpenTldResults = () => {
  const {
    navigateTo
  } = useViewTransition();
  return useCallback((tld, cardBi) => {
    const {
      siteName
    } = getPremiumEssentialsSafe() ?? {};
    const domain = buildDomainFromSiteName(siteName, tld);
    const searchSiteNameWithTld = !isDefaultSiteName(siteName) && !!domain;
    DomainSearchGateModule.internals.bi.onGateTldClick == null || DomainSearchGateModule.internals.bi.onGateTldClick({
      ...cardBi,
      tld,
      domain: searchSiteNameWithTld ? domain : undefined,
      isSearchExecuted: searchSiteNameWithTld
    });
    if (!searchSiteNameWithTld) {
      navigateTo(`/results?${TLD_PREFILL_QUERY_PARAM}=${encodeURIComponent(tld)}`);
      return;
    }
    tldClickSearchService.mark(domain);
    CoreDomainSearchStore.setQuery(domain);
    CoreDomainSearchStore.setSubmittedDomain(domain);
    CoreDomainSearchStore.setSubmittedFilters({
      query: domain,
      tlds: [],
      keywords: [],
      style: ''
    });
    navigateTo(`/results?q=${encodeURIComponent(domain)}`);
  }, [navigateTo]);
};
//# sourceMappingURL=useOpenTldResults.js.map